export const HISTORICAL_DATA_FEATURE = "historical_data";

export const HISTORICAL_DATA_GLOBAL_HINT =
  "Global gives access to every Historical Data dashboard, including UK Bar.";
